export enum FeeTypeEnumDisplay {
	MONTHLY = 'Monthly',
	ACTIVATION = 'Activation',
	ACCESS_DEVICE = 'Access Device',
	LOST_DEVICE = 'Lost Device',
	CREDIT_CARD = 'Credit Card',
	MAIL_INVOICE = 'Mail Invoice',
	LATE = 'Late',
	RECURRING_LATE = 'Recurring Late',
	BEGINNING_BALANCE = 'Beginning Balance',
	TRANSACTION = 'Transaction',
	VALIDATION = 'Validation',
	HOTEL_STORAGE = 'Hotel Storage',
	OFFICE_RETAIL_RENT = 'Office/Retail Rent',
	MANUAL_MONTHLY = 'Manual Monthly',
	MISCELLANEOUS = 'Miscellaneous',
	APPLIED_CREDIT = 'Applied Credit',
	CARRYOVER = 'Carryover',
	DAILY_AND_HOURLY = 'Daily & Hourly',
	NONRECURRING_PAYMENT = 'Nonrecurring Payment',
}
